<template>
  <vs-popup title="Hatalı Ürünler" :active.sync="isActiveLocal" fullscreen>
    <b-row align-h="start" class="mb-1">
      <b-col cols="12" md="auto">
        <v-select v-model="searchField" :options="searchFieldOptions" label="text" :reduce="option => option.value"
          :clearable="false" :searchable="false" placeholder="Arama Yöntemi" style="min-width: 180px" />
      </b-col>
      <b-col cols="12" md="auto">
        <b-form-input v-model="searchValue" @keyup.enter="getFaultyProducts()" placeholder="Ara" />
      </b-col>
      <b-col cols="12" md="auto">
        <b-button v-on:click="getFaultyProducts()" class="bg-primary-gradient" style="border-color:white !important;">
          Ara
        </b-button>
      </b-col>
      <b-col cols="12" md="auto" v-if="searchValue">
        <b-button variant="outline-secondary" v-on:click="clearSearch()">Temizle</b-button>
      </b-col>
    </b-row>
    <div id="loading-faultyProducts" class="vs-con-loading__container">
      <ag-grid-vue style="width: 100%; height: 500px" class="ag-theme-alpine" :defaultColDef="defaultColDef"
        :columnDefs="columnDefs" :rowData="faultyList" :localeText="localeText" :masterDetail="true"
        :detailCellRendererParams="detailParams" :detailRowAutoHeight="true">
      </ag-grid-vue>
    </div>
    <div class="d-flex align-items-center mt-1">{{ faultyList ? faultyList.length : 0 }} adet hatalı ürün</div>
  </vs-popup>
</template>

<script>
import vSelect from "vue-select";
import state from "../../store/state";
import Store from "../../store/store";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      faultyList: null,
      columnDefs: null,
      localeText: null,
      searchValue: "",
      searchFieldOptions: [
        { value: "UrunAdi", text: "Ürün Adı" },
        { value: "StokKodu", text: "Stok Kodu" },
        { value: "Barkod", text: "Barkod" },
        { value: "Pazaryeri", text: "Pazaryeri" }
      ],
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      detailParams: {
        detailGridOptions: {
          columnDefs: [
            { field: "tarih", headerName: "Tarih", filter: "agSetColumnFilter", width: 190 },
            {
              field: "mesaj",
              headerName: "Hata / Mesaj",
              filter: "agSetColumnFilter",
              flex: 1,
              wrapText: true,
              autoHeight: true
            }
          ],
          defaultColDef: { sortable: true, resizable: true }
        },
        getDetailRowData: function (params) {
          let errors = params.data.alan7;
          params.successCallback(Array.isArray(errors) ? errors : []);
        }
      }
    };
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) this.$emit("close");
      }
    }
  },
  watch: {
    isActive(val) {
      if (val) {
        this.searchValue = "";
        this.getFaultyProducts();
      }
    }
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
  },
  methods: {
    clearSearch() {
      this.searchValue = "";
      this.getFaultyProducts();
    },
    getFaultyProducts() {
      var vm = this;
      var vs = this.$vs;
      let type = "radius";
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        Pazaryeri: vm.searchField === "Pazaryeri" ? vm.searchValue : "",
        StokKodu: vm.searchField === "StokKodu" ? vm.searchValue : "",
        Barkod: vm.searchField === "Barkod" ? vm.searchValue : "",
        UrunAdi: vm.searchField === "UrunAdi" ? vm.searchValue : ""
      };
      vs.loading({
        container: "#loading-faultyProducts",
        type
      });
      soap.createClient(url, function (err, client) {
        client.pazaryerifiyathatalistesi(args, function (err, result) {
          if (result.pazaryerifiyathatalistesiResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vs.loading.close("#loading-faultyProducts > .con-vs-loading");
            let parsed = JSON.parse(result.pazaryerifiyathatalistesiResult);
            let list = parsed && Array.isArray(parsed.liste) ? parsed.liste : [];
            vm.columnDefs = [];
            if (list.length > 0) {
              Object.keys(list[0]).forEach((val) => {
                // alan7 hataları satır altında collapse (master/detail) olarak gösterilecek
                if (val === "alan7") return;
                let col = { field: val, filter: "agSetColumnFilter" };
                // ilk kolona aç/kapa okunu ekle
                if (vm.columnDefs.length === 0) {
                  col.cellRenderer = "agGroupCellRenderer";
                  col.pinned = "left";
                }
                vm.columnDefs.push(col);
              });
            }
            vm.faultyList = list;
          } catch (error) {
            vs.loading.close("#loading-faultyProducts > .con-vs-loading");
            vs.notify({
              title: "Hatalı Ürünler",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    }
  }
};
</script>
